
import { useState, FormEvent } from 'react';

export default function Contact() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const response = await fetch('https://readdy.ai/api/form/d5p35gkue1sdfststfsg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({ email }).toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 px-10 bg-gray-50">
      <div className="max-w-7xl mx-auto bg-black rounded-t-[32px] p-20">
        <div className="grid grid-cols-10 gap-16 mb-16">
          <div className="col-span-4">
            <h2 className="text-6xl font-thin text-white leading-tight mb-6">Get In Touch</h2>
            <p className="text-gray-400 text-sm mb-16">Contact our team for inquiries</p>
            
            <form onSubmit={handleSubmit} data-readdy-form id="contact-form">
              <input
                type="email"
                name="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border-b border-gray-700 text-white placeholder-gray-500 py-3 focus:outline-none focus:border-gray-500 transition-colors text-base"
                required
              />
              
              <button
                type="submit"
                disabled={isSubmitting}
                className="mt-6 inline-flex items-center gap-3 bg-white text-black px-8 py-3 rounded-full text-sm font-medium hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
              >
                {isSubmitting ? 'Sending...' : 'Contact'}
                <i className="ri-arrow-right-line"></i>
              </button>

              {submitStatus === 'success' && (
                <p className="mt-4 text-green-400 text-sm">Thank you! We'll get back to you soon.</p>
              )}
              {submitStatus === 'error' && (
                <p className="mt-4 text-red-400 text-sm">Something went wrong. Please try again.</p>
              )}
            </form>
          </div>

          <div className="col-span-2">
            <h3 className="text-xs uppercase text-gray-400 mb-6 tracking-wider">Navigation</h3>
            <div className="flex flex-col gap-4">
              {['home', 'about', 'products', 'features'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item)}
                  className="text-white text-base underline text-left capitalize hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item}
                </button>
              ))}
            </div>
          </div>

          <div className="col-span-4">
            <h3 className="text-xs uppercase text-gray-400 mb-6 tracking-wider">Contact Information</h3>
            
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-phone-line text-gray-400 text-base w-5 h-5 flex items-center justify-center"></i>
                <span className="text-white text-base">Phone</span>
              </div>
              <p className="text-gray-300 text-base">+1 3206333261</p>
            </div>

            <div className="mb-10">
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-mail-line text-gray-400 text-base w-5 h-5 flex items-center justify-center"></i>
                <span className="text-white text-base">Email</span>
              </div>
              <p className="text-gray-300 text-base">support@sylpasrl.com</p>
            </div>

            <div>
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-map-pin-line text-gray-400 text-base w-5 h-5 flex items-center justify-center"></i>
                <span className="text-white text-base">Address</span>
              </div>
              <p className="text-gray-300 text-base leading-relaxed">
                ALVARO BARROS 266<br />
                Viedma, R8500FFF<br />
                Argentina
              </p>
            </div>
          </div>
        </div>

        <div className="pt-12 border-t border-gray-800 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 text-xs underline hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              Website Builder
            </a>
          </div>
          <p className="text-gray-400 text-xs">© 2025 SYLPA S.R.L. All rights reserved</p>
          <div className="flex items-center gap-6">
            <span className="text-gray-400 text-xs underline cursor-pointer whitespace-nowrap hover:text-gray-300 transition-colors">Privacy Policy</span>
            <span className="text-gray-400 text-xs underline cursor-pointer whitespace-nowrap hover:text-gray-300 transition-colors">Terms of Service</span>
          </div>
        </div>
      </div>
    </section>
  );
}
